import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HomePage } from "./pages/HomePage";
import { CoachingPage } from "./pages/CoachingPage";
import { AboutPage } from "./pages/AboutPage";
import { WorkshopsPage } from "./pages/WorkshopsPage";
import { ContactPage } from "./pages/ContactPage";
import { TableOfContents } from "./pages/TableOfContents";
import { ChapterView } from "./pages/ChapterView";
import { MyJournal } from "./pages/MyJournal";
import { FreebiesLanding } from "./pages/FreebiesLanding";
import { FreeChapter1 } from "./pages/FreeChapter1";
import { FiveLiesGuide } from "./pages/FiveLiesGuide";
import { SalesPage } from "./pages/SalesPage";
import { PurchaseSuccess } from "./pages/PurchaseSuccess";
import { LinkInBio } from "./pages/LinkInBio";
import { Downloads } from "./pages/Downloads";
import { Workshop } from "./pages/Workshop";
import { SocialFlyer } from "./pages/SocialFlyer";
import { CardShop } from "./pages/CardShop";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/coaching" element={<CoachingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/workshops" element={<WorkshopsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contents" element={<TableOfContents />} />
          <Route path="/chapter/:id" element={<ChapterView />} />
          <Route path="/journal" element={<MyJournal />} />
          <Route path="/free" element={<FreebiesLanding />} />
          <Route path="/free/chapter-1" element={<FreeChapter1 />} />
          <Route path="/free/5-lies" element={<FiveLiesGuide />} />
          <Route path="/purchase" element={<SalesPage />} />
          <Route path="/purchase/success" element={<PurchaseSuccess />} />
          <Route path="/links" element={<LinkInBio />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/workshop" element={<Workshop />} />
          <Route path="/flyer" element={<SocialFlyer />} />
          <Route path="/cards" element={<CardShop />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
